/**
 * On mobile browsers, setting a height of 100vh doesn't
 * work because the address bar and other paraphenalia
 * is not included in the computation.
 * per https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html
 * this is best fixed with JS on page load.
 */
export class HeightResize {
	static resize(el) {
		let p = el.getAttribute(`data-height-resize`) / 100;
		el.removeAttribute(`data-height-resize`);
		let resize = function(evt) {
			el.style.height = `${p * window.innerHeight}px`;
		}
		resize();
		window.addEventListener(`resize`, resize);
	}
	static init() {
		for (let el of document.querySelectorAll(`[data-height-resize]`)) {
			HeightResize.resize(el);
		}
	}
}